import React from "react";
import { FaMoon, FaSun } from "react-icons/fa";
import { useTheme } from "../../theme/ThemeContext";
import "./ThemeToggle.css";

// Header button that switches between light and dark mode.
const ThemeToggle = ({ className = "" }) => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";
  const label = isDark ? "Switch to light mode" : "Switch to dark mode";

  return (
    <button
      type="button"
      className={`header-icon-btn theme-toggle-btn ${className}`.trim()}
      onClick={toggleTheme}
      title={label}
      aria-label={label}
      aria-pressed={isDark}
    >
      {isDark ? <FaSun /> : <FaMoon />}
    </button>
  );
};

export default ThemeToggle;
